export const CASE_STATUS_CHANGE_DEFAULT = 0;
export const CASE_STATUS_CHANGE_APPROVED = 1;
export const CASE_STATUS_CHANGE_REJECTED = 2;
